import React, { useEffect } from 'react';

import ContentCard from '../../../../components/ContentCard';
import SkeletonStack from '../../../../components/SkeletonStack';
import { getCurrentUserId } from '../../../../services/auth';
import { useGetExamAttemptsByUserQuery } from '../../../../services/exams';
import { ExamAttempt } from '../../../../services/exams/types';
import { ContentContainer } from '../../index.styles';
import AttemptsList from '../AttemptsList';

interface AttemptsTabProps {
  title: string;
  isMarked: boolean;
}

const AttemptsTab = ({ title, isMarked }: AttemptsTabProps) => {
  const userId = getCurrentUserId();

  const [filteredAttempts, setFilteredAttempts] = React.useState<ExamAttempt[]>([]);

  const { data: examAttempts, isLoading: isExamAttemptsLoading } = useGetExamAttemptsByUserQuery(
    { marker: userId, marked: isMarked }, { skip: !userId },
  );

  useEffect(() => {
    if (examAttempts) {
      setFilteredAttempts(examAttempts.data.filter(
        (attempt) => !!attempt.markedDatetime === isMarked),
      );
    }
  }, [examAttempts]);

  if (isExamAttemptsLoading) {
    return <SkeletonStack />;
  }

  return (
    <ContentContainer>
      <ContentCard variant="outlined" title={title}>
        <AttemptsList
          rows={filteredAttempts}
          isMarked={isMarked}
        />
      </ContentCard>
    </ContentContainer>
  );
};

export default AttemptsTab;
